import React from 'react'
import DocumentTitle from 'react-document-title'

export default class Shuttle extends React.Component {
	render() {
		return (
			<DocumentTitle title='Shuttle Info'>
				<article className='content'>
					<h2 className='title'>Shuttle Info</h2>
					<p>For the ease and safety of our guests, we're providing a shuttle service from the Best Western to the Moore Mansion before the ceremony and from the Moore Mansion to the Best Western after the reception.</p>
					<p>The shuttle from the Best Western will be leaving at <strong>3:45pm</strong> and <strong>4:45pm</strong>. There are only the two shuttles; if you miss both, you'll need to find your own way to the Mansion before the ceremony starts. To get on the shuttle, meet in the lobby of the hotel by the sign and look for Jo Laneve.</p>
					<p>The shuttle from the Moore Mansion will be leaving starting at <strong>9:30pm</strong>, and will be running hourly after that. Listen for the DJ's announcements about where to meet and when the shuttle arrives.</p>
				</article>
			</DocumentTitle>
		)
	}
}



// WEBPACK FOOTER //
// ./client/components/Shuttle/index.jsx